import React from 'react'
import RecentActivityPageEu from './RecentActivityEu'

const RecentActivityEu = () => (
    <RecentActivityPageEu/>
)

export default RecentActivityEu